import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Event } from '@api/models/event/event';
import { ContentCardLayout } from '@lib-modules/cards/components/content-card/content-card.component';
import { ColorScheme } from '@lib/models/color-scheme/color-scheme';
import {SectionHeaderTitleSize} from '@lib-modules/section/components/section-header/section-header.component';
import { SportTypeService } from '@api/services/sport-type/sport-type.service';
import { SportType } from '@lib/models/sport-type/sport-type';
import {EventCardService} from '@lib-modules/cards/services/event-card/event-card.service';

export enum MatchSectionLayout {
  Default,
  Minimal
}

@Component({
  selector: 'lib-match-section',
  templateUrl: './match-section.component.html',
  styleUrls: [
    './match-section.component.scss',
    '../../styles/section-styles.scss'
  ],
})
export class MatchSectionComponent implements OnInit {

  public isFootball: boolean;
  public cardLayout = ContentCardLayout.Square;
  @Input() public sportType: SportType;
  @Input() public matches: Event[];
  @Input() public live = false;
  @Input() public itemLinkPath: string;
  @Input() public title: string;
  @Input() public titleIcon: string;
  @Input() public titleSize = SectionHeaderTitleSize.Large;
  @Input() public colorScheme = ColorScheme.Dark;
  @Input() public moreButtonTitle = "Mehr Spiele";
  @Input() public moreButtonLink: string;
  @Input() public moreButtonRouterLink: string;
  @Input() public layout = MatchSectionLayout.Default;
  @HostBinding("class.minimal") public isMinimalLayout = false;

  constructor(public matchService: EventCardService) { }

  public async ngOnInit() {
    if (!this.sportType) {
      this.sportType = SportTypeService.selectedSportType;
    }
    this.isFootball = this.sportType === SportType.Football;
    this.isMinimalLayout = this.layout === MatchSectionLayout.Minimal;
    if (this.isMinimalLayout) {
      this.cardLayout = ContentCardLayout.Minimal;
    }
  }

}
